<template>
 <div id="text">

   <article class="message">
     <figure id="card-image" class="image">
       <img src="public/assets/library-cards-small.jpg"/>
     </figure>
     <div class="message-body">
       <div class="ptext">What is it that gives investigative journalists their identity, and their elevated status in society? Is it their skills, or perhaps their heroism in the face of adversity?</div>
       <div class="ptext">The problem with this approach is that traits and mythologies provide little analytical purchase, in terms of helping us understand what investigative journalism is, what it has given us, and where it is going, in an increasingly fragmented media landscape.</div>

       <div class="ptext">Today, open-source intelligence is challenging form and practice in the field; making possible new partnerships, new methodologies and new working routines. This project is concerned with better understanding these changes; and where they fit in the history of British investigative journalism, 1800-2020.</div>
     </div>
   </article>

   <div class="ptext">Across these pages, we present a different way of understanding the evolution of investigative journalism in the UK, from conventional, narrative-based histories. We take an interdisciplinary, experimental approach that is concerned with both discourses and data.</div>

   <div class="ptext">Investigative journalism is here conceived of as a <em>multilevel discourse</em>, comprising, at the same time and by degrees of emphasis; a theory (or proof), an aesthetic, a tool (or means of change), and an ideology. It is possible to capture three of these four discourses as scalable variables: theory (methods used, scaled from transparent to opaque); aesthetics (the language or visuals used; scaled from impartial to sensational), and pragmatics (the sphere of impact; scaled from public to private).</div>
     <div class="ptext">This site provides various ways of exploring these data, along with other quantitative and qualitative data (for example, production staff, and viewing figures), drawing upon visual methods from the field of data science. It is within and amongst these data that the contour of three different contingent forms, or genres of investigative journalism (namely Intelligence, Improving and Impactful) may be analysed, and better understood; towards providing a new synthetic appraisal of the history of British investigative journalism, 1800-2020.</div>
   <div class="ptext">This project represents a proof of concept. Funding is currently being sought to populate it with accurate data concerning 150-200 ideal-typical investigations; to establish a canon of 10 best investigations, and to incorporate further learning materials (including bespoke videos) into this resource, in order to raise awareness about the importance of investigative journalism to the UK.</div>
   <div class="ptext">This resource is currently populated with dummy data.</div>

 </div>

</template>

<script>
    export default {
        name: "AppText"
    }
</script>

<style scoped>

  #text {
    width: 100%
  }
  .ptext {
    padding: 5px;
  }
  em {
    font-weight: 500
  }

  #card-image {
    float: right;
    max-width: 100%;
    height: auto;
  }

  .message-body {
    width: 80%;
    font-size: 1.1em;
  }

  .message {
    min-height: 248px;
  }


</style>
